import { Button } from '~ui/base/button';
import { Typography } from '~ui/base/typography';

interface SearchPaginationProps {
  page: number;
  totalCount: number;
  pageSize: number;
  hasMore: boolean;
  onPageChange: (page: number) => void;
}

function SearchPagination({
  page,
  totalCount,
  pageSize,
  hasMore,
  onPageChange,
}: SearchPaginationProps) {
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  if (totalPages <= 1) return null;

  return (
    <nav
      aria-label="Search results pagination"
      className="flex items-center justify-between gap-x-4 pt-2"
    >
      <Button
        variant="secondary"
        size="md"
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page <= 1}
      >
        Previous
      </Button>
      <Typography variant="caption-md" as="span" className="text-muted-foreground">
        Page {page} of {totalPages}
      </Typography>
      <Button
        variant="primary"
        size="md"
        onClick={() => onPageChange(page + 1)}
        disabled={!hasMore}
      >
        Next
      </Button>
    </nav>
  );
}

export { SearchPagination };
